import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbAuthOAuth2JWTToken, NbTokenService } from '@nebular/auth';
import { LogowanieService } from '../../@core/http/logowanie.service';
import { TokenResponse } from '../../shared/models/logowanie.model';

@Component({
  selector: 'ngx-relogin',
  templateUrl: './relogin.component.html',
  styleUrls: ['./relogin.component.scss'],
})
export class ReloginComponent implements OnInit {

  constructor(
    private activeRoute: ActivatedRoute,
    private logowanieService: LogowanieService,
    private router: Router,
    private tokenService: NbTokenService,
  ) { }

  ngOnInit() {
    const klient = this.activeRoute.snapshot.paramMap.get('klient');
    if (klient) {
      this.logowanieService.zmienKlienta(klient).subscribe(
        tokenResponse => {
          this.tokenService.set(this.getJWTToken(tokenResponse)).subscribe(() => {
            this.router.navigateByUrl('/pages/przychody-koszty');
          });
        },
        error => {
          this.router.navigateByUrl('/login');
        });
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  private getJWTToken(tokenResponse: TokenResponse) {
    return new NbAuthOAuth2JWTToken(
      {
        'access_token': tokenResponse.token.access_token,
        'refresh_token': tokenResponse.token.refresh_token,
      },
      'token',
    );
  }
}
